export default __webpack_public_path__ + "d726a4740c890e3eaaac3e750ef3fdaa.svg";